import { useTheme } from '@mui/material/styles';

import { Typography, Grid } from '@mui/material';
import Logo from './LogoImage';
const LogoText = () => {
    const theme = useTheme();
    return (
        <Grid container>
            <Grid item sm={12} display="flex" alignItems="center" gap={1}>
                <Logo width="33%" />
                <Grid container display="block">
                    <Grid item>
                        <Typography
                            variant="h6"
                            sx={{ textDecoration: 'none', color: theme.palette.primary.main, fontFamily: 'URW DIN BOLD' }}
                        >
                            LLN
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography
                            variant="h3"
                            sx={{ textDecoration: 'none', color: theme.palette.primary.main, fontFamily: 'URW DIN BOLD' }}
                        >
                            ROBOT
                        </Typography>
                    </Grid>
                    <Grid item sx={{ marginTop: '-6px' }}>
                        <Typography
                            variant="h2"
                            sx={{ textDecoration: 'none', color: theme.palette.primary.main, fontFamily: 'URW DIN BOLD' }}
                        >
                            DASH
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default LogoText;
